module.exports = __webpack_public_path__ + "img/4.f28c6906.png";